import { render, staticRenderFns } from "./UpgradeBase.vue?vue&type=template&id=495b2a37&"
import script from "./UpgradeBase.vue?vue&type=script&lang=js&"
export * from "./UpgradeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports